(() => {
  'use strict';
  const configNode = document.getElementById('neko-member-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const endpoint = config.staging
    ? 'https://neko-waiting-room.vercel.app/api/queue/explore-preview'
    : '/apps/queue/explore-preview';
  let data = new Map(), inFlight = false, lastFetch = 0, queued = false;
  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const roots = () => [...document.querySelectorAll('[data-member-preview-stats]')];
  const render = () => roots().forEach(root => {
    const variant = root.hasAttribute('data-preview-product')
      ? new URLSearchParams(location.search).get('variant') || root.dataset.memberVariant
      : root.dataset.memberVariant;
    const stats = data.get(String(variant));
    setText(root.querySelector('[data-preview-remaining]'), stats ? String(stats.ticketsLeft) : '—');
    setText(root.querySelector('[data-preview-total]'), stats ? String(stats.ticketsTotal) : '—');
    root.querySelectorAll('[data-preview-tier]').forEach(card => {
      const tier = card.dataset.previewTier;
      const value = ['D', 'E', 'F'].includes(tier) ? stats?.tiers?.find(t => t.tier === tier) : null;
      setText(card.querySelector('[data-preview-count]'), value ? `${value.remaining}/${value.total}` : '—/—');
      setText(card.querySelector('[data-preview-points]'), value?.pointValue > 0 ? `(${value.pointValue}分)` : '\u00a0');
      card.classList.toggle('sold-out', !!value && value.remaining === 0);
    });
  });
  const load = async () => {
    if (document.hidden || !roots().length || inFlight || Date.now() - lastFetch < 10000) return;
    inFlight = true; lastFetch = Date.now();
    try {
      const response = await fetch(endpoint, { cache: 'no-store', credentials: 'omit', signal: AbortSignal.timeout(8000) });
      if (!response.ok) throw new Error('preview_unavailable');
      const payload = await response.json();
      if (!Array.isArray(payload.items)) throw new Error('invalid_preview');
      data = new Map(payload.items.map(item => [String(item.variantId), item.stats]));
      render();
    } catch { /* Keep the last verified counts or an explicit unavailable dash. */ }
    finally { inFlight = false; }
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; render(); load(); });
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('change', schedule);
  window.addEventListener('popstate', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  setInterval(load, 30000);
  schedule();
})();
